<template>
  <div class="incomeFlow">
     <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- <div style="float:left;">
          <el-button type="text" style="font-size:17px;">金额：{{totalMoney}}</el-button>
        </div> -->
        <span style="line-height: 36px; text-align: center;">运维轨迹</span>
        <div style="float:right">
  
          <el-select v-model="alarmType" placeholder="账号级别" class="acclevel">
            <el-option
              v-for="item in alarmTypes"
              :key="item.name"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-select v-model="alarmStatus" placeholder="状态">
            <el-option
              v-for="item in alarmStatuses"
              :key="item.value"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select> -->
          <el-date-picker
            v-model="startTime"
            value-format="yyyy-mm-dd"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期">
          </el-date-picker> -->
          <el-button type="success" @click="btnSearch">查询</el-button>
        </div>
      </div>
      <div>
        <div id="container" style="width:100%;height:90vh" />
      </div>
      <!-- <div class="table_pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div> -->
    </el-card>
    </div>
  </template>
  <script>
      import $axios from '../../https/config'
  
      // 绘制线路需要的坐标
var lineArr = [[116.478935, 39.997761], [108.983569, 34.285675], [103.85094, 35.987496], [106.205794, 38.458831], [111.761777, 40.875595]]
export default {
  data () {
    return {
      firstArr: [108.983569, 34.285675], // 中心点/初始坐标
      startTime: '',
      alarmTypes: [],
      alarmType: '',
    }
  },
  created () {

    this.getAccountList()
  },
  mounted () {
    setTimeout(() => {
      this.initMap() // 异步加载（否则报错initMap is not defined）
      // this.initroad()
    }, 1000)
  },
 
  methods: {
    queryDeviceList ( tFaultId, startTime) {
            // var _this = this
            // var params = {
            //   pageNo: tPageNo,
            //   pageSize: tPageSize,
            //   userId: tFaultId + '',
            //   status: tStatus,
            //   type: tType,
            //   startTime: startTime === '' ? '' : new Date(startTime).getFullYear() + '-' + (new Date(startTime).getMonth() + 1) + '-' + new Date(startTime).getDate(),
            //   endTime: endTime === '' ? '' : new Date(endTime).getFullYear() + '-' + (new Date(endTime).getMonth() + 1) + '-' + new Date(endTime).getDate()
            // }
            // this.table_loading = true
            // this.deviceData = []
            if (startTime != ''){
              var now = new Date(startTime);                                                                                                     
              var year = now.getFullYear(); //得到年份
              var month = now.getMonth();//得到月份
              var date = now.getDate();//得到日期
              month = month + 1;
              if (month < 10) month = "0" + month;
              if (date < 10) date = "0" + date;
              startTime = year + "-" + month + "-" + date;
            }
            
            //startTime = startTime === '' ? '' : new Date(startTime).getFullYear() + '-' + (new Date(startTime).getMonth() + 1) + '-' + new Date(startTime).getDate()
            console.log("userId="+tFaultId+",startTime="+startTime);

            var _this = this
            var params = {          
              userId: tFaultId + '',
              startTime: startTime 
            }
            this.table_loading = true
            this.deviceData = []

            this.initroad();

            $axios.post('/adminApp/getGps', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                if (res.resultData && res.resultData.list.length > 0) {
                  

                }
              } else {
              }
              _this.table_loading = false
            }, function () {
            })
          },
    btnSearch () {
            this.queryDeviceList(this.alarmType, this.startTime)
     },
    // 初始化地图
    initMap () {
      var that = this
      this.map = new AMap.Map('container', {
        resizeEnable: true, // 窗口大小调整
        center: this.firstArr, // 中心 firstArr: [116.478935, 39.997761],
        zoom: 18
      })
      // 添加maker
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.firstArr,
        icon: 'https://webapi.amap.com/images/car.png',
        offset: new AMap.Pixel(-26, -13), // 调整图片偏移
        autoRotation: true, // 自动旋转
        angle: -90 // 图片旋转角度
      })
      //that.initroad()
    },
    // 初始化轨迹
    initroad () {
      // 绘制还未经过的路线
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: lineArr,
        showDir: true,
        strokeColor: '#77DDFF', // 线颜色--浅蓝色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, // 线宽
        // strokeStyle: "solid"  //线样式
        lineJoin: 'round' // 折线拐点的绘制样式
      })

      lineArr.forEach((el,index)=>{
        console.log(el);
            let maker= new AMap.Marker({
              position: new AMap.LngLat(el.lng,el.lat),
              content: "hahah", // 这里传入dom
              offset: new AMap.Pixel(0, -34)  //这里注意偏移量，默认左上角定位在坐标点，如需dom中心对准坐标点 则需要 向左向右偏移 宽高的一半 为负数，
            });
            this.map.add(maker)
          })
      // 绘制路过了的轨迹
      // var passedPolyline = new AMap.Polyline({
      //   map: this.map,
      //   strokeColor: '#00BBFF', // 线颜色-深蓝色
      //   path: [[116.478935, 39.997761], [108.983569, 34.285675]],
      //   // strokeOpacity: 1,     //线透明度
      //   strokeWeight: 6 // 线宽
      //   // strokeStyle: "solid"  //线样式
      // })
      this.map.setFitView() // 合适的视口
    },
    getAccountList () {
        var _this = this
        $axios.get('/system/queryAcccount', null, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            for (let i = 0; i < res.resultData.list.length; i++) {
              var usertype = res.resultData.list[i].user_type === 1 ? '代理商' : '设备主'
              _this.alarmTypes.push({
                id: res.resultData.list[i].id,
                name: usertype + '-' + (res.resultData.list[i].nickName!=null?res.resultData.list[i].nickName:res.resultData.list[i].user_name)+"-"+(res.resultData.list[i].id)
              })
            }
            // _this.alarmTypes.unshift({
            //   id: '',
            //   name: '全部账号'
            // })
          }
        })
      },
  }
}

  </script>
  <style lang="scss">
      .table_pagination {
        text-align: right;
        margin-top: 10px; 
      }
      .incomeFlow {
          .el-select .el-input {
            width: 110px;
          }
          .acclevel .el-input{
            width: 200px;
          }
      }
  </style>


// WEBPACK FOOTER //
// src/page/opMgr/gpsRecord.vue